"use client";

import { useState } from "react";
import Link from "next/link";

type Msg = { from: "bot" | "user"; text: string };

const quickReplies = [
  "Kargo ne kadar sürer?",
  "İade nasıl yapılır?",
  "Hangi oje bana uygun?",
  "İndirim kodu var mı?",
];

export function LiveSupport() {
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState<Msg[]>([
    { from: "bot", text: "Merhaba! Ben Ono MAC asistanın ✨ Sana nasıl yardımcı olabilirim?" },
  ]);

  const send = (text: string) => {
    if (!text.trim()) return;
    setMessages((m) => [...m, { from: "user", text }, { from: "bot", text: getBotReply(text) }]);
    setInput("");
  };

  return (
    <>
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? "Canlı desteği kapat" : "Canlı desteği aç"}
        className="fixed bottom-5 right-5 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-Primary text-white shadow-lg hover:bg-Primary-dark hover:scale-105 transition-all sm:bottom-6 sm:right-6 sm:h-14 sm:w-14"
      >
        <span className="text-lg">{open ? "✕" : "💬"}</span>
        {!open && <span className="absolute -right-1 -top-1 h-3 w-3 rounded-full bg-emerald-500 border-2 border-white animate-pulse" />}
      </button>

      {open && (
        <div className="fixed bottom-20 right-4 z-40 w-[92vw] max-w-sm overflow-hidden rounded-[1.5rem] border bg-white shadow-2xl sm:bottom-24 sm:right-6">
          <div className="bg-Primary-dark px-4 py-3 text-white flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-White/20 text-sm font-bold">O</span>
              <div>
                <p className="text-sm font-semibold">Ono MAC Canlı Destek</p>
                <p className="text-xs text-white/70">Genellikle 2 dk içinde yanıt • 09:00–22:00</p>
              </div>
            </div>
            <button onClick={() => setOpen(false)} className="flex h-7 w-7 items-center justify-center rounded-full bg-white/10 hover:bg-white/20">✕</button>
          </div>

          <div className="h-64 overflow-y-auto p-4 space-y-3 bg-zinc-50">
            {messages.map((m, i) => (
              <div key={i} className={`flex ${m.from === "user" ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[78%] rounded-2xl px-3.5 py-2 text-sm ${m.from === "user" ? "bg-Primary text-white" : "bg-white border shadow-sm"}`}>{m.text}</div>
              </div>
            ))}
          </div>

          <div className="border-t bg-white p-2">
            <div className="flex flex-wrap gap-1.5 pb-2">
              {quickReplies.map((q) => (
                <button key={q} onClick={() => send(q)} className="rounded-full border bg-white px-2.5 py-1 text-xs hover:bg-zinc-50">
                  {q}
                </button>
              ))}
            </div>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                send(input);
              }}
              className="flex gap-2"
            >
              <input
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="Mesaj yaz..."
                className="flex-1 rounded-full border bg-zinc-50 px-4 py-2 text-sm focus:bg-white focus:outline-none focus:ring-2 focus:ring-[var(--brand-light)]"
              />
              <button type="submit" className="rounded-full bg-Primary px-4 py-2 text-sm font-medium text-white hover:bg-Primary-dark disabled:opacity-50" disabled={!input.trim()}>
                Gönder
              </button>
            </form>
            <div className="mt-2 flex items-center justify-between text-xs text-zinc-500">
              <span>WhatsApp’a geçmek ister misin?</span>
              <a href="https://wa.me/905558116813" target="_blank" rel="noreferrer" className="font-medium text-Primary hover:underline">
                WhatsApp →
              </a>
            </div>
            <div className="mt-1 flex gap-2 text-xs">
              <Link href="/iletisim" className="underline hover:text-Primary">İletişim</Link>
              <span>•</span>
              <Link href="/sikca-sorulan-sorular" className="underline hover:text-Primary">SSS</Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function getBotReply(q: string): string {
  const t = q.toLowerCase();
  if (t.includes("kargo")) return "1500₺ ve üzeri kargo bedava! İstanbul içi 24 saat, diğer iller 1-3 iş günü. Takip için /siparisler.";
  if (t.includes("iade")) return "14 gün içinde koşulsuz iade — açılmamış ürün, anlaşmalı kargo. Detay: /iade-degisim";
  if (t.includes("oje") || t.includes("uygun")) return "Cilt alt tonuna göre: sıcak alt tonda nude/şeftali, soğukta pembe/kırmızı. Kararsızsan quiz yakında!";
  if (t.includes("indirim")) return "Kod: YAZ20 ile %20, HOSGELDIN10 ile %10 — sepet te uygula. Kampanyalar: /kampanyalar";
  return "Anladım — en kısa sürede ekibimiz dönüş yapacak. Acil ise WhatsApp’tan yazabilirsin 💚";
}
